<div class="input-file-container" appDragDrop (fileDropped)="editMode() ? onFileDropped($event) : null" [class.drag-disabled]="!editMode()">
  @if (processing) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <div class="files-container" cdkDropList cdkDropListOrientation="mixed" [cdkDropListData]="files" [cdkDropListDisabled]="!editMode()" (cdkDropListDropped)="onDropped($event)">
    @for (file of files; track file; let i = $index) {
      <!-- long press to drag on touch screens, so swiping still scrolls -->
      <div class="file-item" cdkDrag [cdkDragDisabled]="!editMode()" [cdkDragStartDelay]="{ touch: 500, mouse: 0 }">
        <div class="file-container">
          <ng-container *ngTemplateOutlet="fileTemplate; context: { $implicit: file, index: i }"></ng-container>
        </div>
        <img *cdkDragPreview class="drag-preview" [src]="file.preview">
      </div>
    }
  </div>
  @if (canAddFile) {
    <div class="file-container w-100">
      <ng-container *ngTemplateOutlet="addTemplate"></ng-container>
    </div>
  }
</div>

<ng-template #addTemplate>
  <div inputFileDropZone class="file-drop-zone primary-color w-100 flex-row justify-center items-center" (click)="fileInput.click()" (onFilesDropped)="onFileDropped($event)"
    [dropZoneDisabled]="isDisabled">
    <div class="mr-5 text-xxlg">
      <mat-icon class="mat-icon-xxxlg neutral-color">backup</mat-icon>
    </div>
    <div class="flex-col items-center hide-lt-md show-gt-md" >
      <span class="text-muted text-xlg"><strong>Drag and drop files here</strong></span>
      <span class="text-muted text-lg"><strong>or</strong></span>
      <a class="link-active-color text-lg" for="fileDropRef"><strong>Browse for files</strong></a>
    </div>
  </div>
  <input [id]="id" [accept]="fileAccept()" hidden type="file" [attr.multiple]="fileLimit() > 1 ? true : null" #fileInput (change)="onSelectFile(asFileList($event))">
</ng-template>

<ng-template #fileTemplate let-file let-index="index" >
  @if (file.preview) {
    <img class="image-preview" [src]="file.preview" >
  }
  @if (publicSelection()) {
    @if (editMode()) {
      <button type="button" class="if-public-toggle" [class.if-public]="isPublic(file)" (click)="onTogglePublic(index)" [disabled]="isDisabled"
        [matTooltip]="isPublic(file) ? 'In the public listing, click to make private' : 'Private, click to add to the public listing'">
        <mat-icon>{{ isPublic(file) ? 'public' : 'public_off' }}</mat-icon>
      </button>
    }
    @if (isPublic(file)) {
      <span class="if-public-badge" [matTooltip]="file.publicSequenceNo === 0 ? 'Main image of the public listing' : 'Position in the public listing'">
        {{ file.publicSequenceNo === 0 ? 'Main' : file.publicSequenceNo + 1 }}
      </span>
    }
  }
  @if(canReplaceFile(index)){
    <button mat-button inputFileDropZone class="replace-button" type="button" (click)="fileReplace.click()" (onFilesDropped)="onReplaceFileDropped($event, index)"
      [disabled]="isDisabled" matTooltip="Click to replace">
      @if (!file.preview) {
        <mat-icon class="input-icon">{{ iconFile() }}</mat-icon>
      }
      @if (!file.preview && file.file) {
        <div class="file-name text-truncate">{{ file.file.name }}</div>
      }
    </button>
  }
  <span class="flex-row justify-center">
    @if (canDeleteFile(index)) {
      <button mat-button class="secondary-button" type="button" (click)="onDeleteFile(index)" [disabled]="isDisabled" matTooltip="Delete">
        <mat-icon class="warn-color mr-0">{{ iconDelete() }}</mat-icon>
      </button>
    }
    @if (canEditFile(index)) {
      <button mat-button class="secondary-button" type="button" (click)="onEditFile(index)" [disabled]="isDisabled" matTooltip="Edit">
        <mat-icon class="primary-color mr-0">{{ iconEdit() }}</mat-icon>
      </button>
    }
  </span>
  <input [accept]="fileAccept()" hidden type="file" #fileReplace (change)="onReplaceFile(asFileList($event), index, fileReplace)">
</ng-template>

